/*
Copyright (c) 2012-2026 Grab Taxi Holdings PTE LTD (GRAB), All Rights Reserved.
NOTICE: All information contained herein is, and remains the property of GRAB.
The intellectual and technical concepts contained herein are confidential,
proprietary and controlled by GRAB and may be covered by patents, patents in process,
and are protected by trade secret or copyright law.

You are strictly forbidden to copy, download, store (in any medium), transmit, disseminate,
adapt or change this material in any way unless prior written permission is obtained from GRAB.
Access to the source code contained herein is hereby forbidden to anyone except current GRAB
employees or contractors with binding Confidentiality and Non-disclosure agreements explicitly
covering such access.

The copyright notice above does not evidence any actual or intended publication or disclosure of
this source code, which includes information that is confidential and/or proprietary,
and is a trade secret, of GRAB.

ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC PERFORMANCE, OR PUBLIC DISPLAY OF OR
THROUGH USE OF THIS SOURCE CODE WITHOUT THE EXPRESS WRITTEN CONSENT OF GRAB IS STRICTLY PROHIBITED,
AND IN VIOLATION OF APPLICABLE LAWS AND INTERNATIONAL TREATIES. THE RECEIPT OR POSSESSION OF THIS
SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS TO REPRODUCE,
DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT MAY DESCRIBE,
IN WHOLE OR IN PART.
*/
import { GrabXDataTypes, GrabXFeatureFlag } from "./types"

export const EMPTY_VARIABLE_NAME = "empty variable name"

export enum MerchantPortalFeatureFlag {
  markOrdersReadyConfig = "markOrdersReadyConfig",
  enableMenuTranslationPortal = "enableMenuTranslationPortal",
  enableMenuGroupMenuTranslationPortal = "enableMenuGroupMenuTranslationPortal",
  brandListing = "enableBrandListingTroyPortal",
  attributeLocalizationEnabled = "IsAttributeLocalizationEnabled",
  portalRetryTimeout = "portalRetryTimeout",
  enableMexSupplier = "enableMexSupplier",
  enableAlcoholSetting = "SelfServeAlcoholTaggingEnabled",
  enableAlcoholSettingMenuGroupV2 = "SelfServeAlcoholTaggingEnabledForMenuGroupV2",
  linkStoreMaxLimit = "linkStoreMaxLimit",
  portalEnableHermesConnection = "portalEnableHermesConnection",
  portalEnablePartialMenu = "portalEnablePartialMenu",
  enableTrackError = "enablePortalTrackError",
  // owner: @leyi.song expected rolout: Jan 2025
  TobaccoSaleEnabled = "TobaccoSaleEnabled",
  TobaccoSaleEnabledForMenuGroupV2 = "TobaccoSaleEnabledForMenuGroupV2",
  // owner: @muhammad.arfandy, don't delete after full rollout
  portalDatadogRumConfig = "portalDatadogRumConfig",
  // owner: @husni.habil, don't delete after full rollout
  enableEditorUIBulkUpload = "enableEditorUIBulkUpload",
  // owner: @novi.steven expected rollout: Oct 2025
  portalEnableBulkUploadProcessingBannerByUploadType = "portalEnableBulkUploadProcessingBannerByUploadType",
  // owner: @muhammad.arfandy expected rollout: Oct 2025, can't be removed after full rollout, its also can be used to check if the store is grab devices store or not
  portalEnableDownloadMpaTransaction = "portalEnableDownloadMpaTransaction",
  // owner: @novi.steven
  portalEnableGrabMexProImageEditor = "portalEnableGrabMexProImageEditor",
  // owner: @wesley.loh expected rollout: Feb 2026
  portalEnableHideItem = "portalEnableHideItem",
  // owner: @husni.habil, list of couriers for mex supplier, not expected to remove
  mexSupplierCourierList = "MexSupplierCourierList",
  // owner: @novi.steven expected rollout: Apr 2026
  portalEnableEcommerceProductMerchantBulkUploadKey = "portalEnableEcommerceProductMerchantBulkUploadKey",
  // owner: @husni.habil
  rtkQueryMigrationEndpointsFlag = "rtkQueryMigrationEndpointsFlag",
  // owner: @ecommerce-web
  enableEcomMenuGroupProductCreation = "enableEcomMenuGroupProductCreation",
  // owner: @ecommerce-web expected rollout: Jul 2026
  portalEnableProductSearch = "portalEnableProductSearch",
}

// list of grabX variable to be pulled
export const GRABX_FLAG_LIST: GrabXFeatureFlag[] = [
  {
    grabxVariableName: MerchantPortalFeatureFlag.brandListing,
    dataType: GrabXDataTypes.Boolean,
    defaultValue: false,
  },
  {
    grabxVariableName: MerchantPortalFeatureFlag.attributeLocalizationEnabled,
    dataType: GrabXDataTypes.Boolean,
    defaultValue: false,
  },
  {
    grabxVariableName: MerchantPortalFeatureFlag.portalRetryTimeout,
    dataType: GrabXDataTypes.Number,
    defaultValue: 0,
  },
  {
    grabxVariableName: MerchantPortalFeatureFlag.linkStoreMaxLimit,
    dataType: GrabXDataTypes.Number,
    defaultValue: 50,
  },
  {
    grabxVariableName: MerchantPortalFeatureFlag.enableTrackError,
    dataType: GrabXDataTypes.Boolean,
    defaultValue: false,
  },
  {
    grabxVariableName: MerchantPortalFeatureFlag.portalEnableHideItem,
    dataType: GrabXDataTypes.Boolean,
    defaultValue: false,
  },
  {
    grabxVariableName: MerchantPortalFeatureFlag.mexSupplierCourierList,
    dataType: GrabXDataTypes.Json,
    defaultValue: [],
  },
  {
    grabxVariableName:
      MerchantPortalFeatureFlag.portalEnableEcommerceProductMerchantBulkUploadKey,
    dataType: GrabXDataTypes.Boolean,
    defaultValue: false,
  },
  {
    grabxVariableName: MerchantPortalFeatureFlag.portalEnableProductSearch,
    dataType: GrabXDataTypes.Boolean,
    defaultValue: false,
  },
  {
    grabxVariableName: MerchantPortalFeatureFlag.rtkQueryMigrationEndpointsFlag,
    dataType: GrabXDataTypes.Json,
    defaultValue: {
      searchOutlets: false,
      searchStore: false,
      fetchItemsWithoutPhotoCount: false,
      fetchIncidentStat: false,
      submitReportReview: false,
      postMerchantReviewThrottle: false,
      fetchMerchantAggregate: false,
      fetchIncidentList: false,
      fetchMerchantDetail: false,
      loadConfig: false,
      uploadReportReviewImg: false,
      fetchOrderEta: false,
      fetchCityList: false,
      fetchOrderSummary: false,
      fetchOrderCancelReasons: false,
      reviewOrderChanges: false,
      submitOrderChanges: false,
      cancelOrder: false,
      fetchOrderExportedMpaFile: false,
      fetchOrderExportedFile: false,
      fetchStoreDetailFromMaxAPI: false,
      fetchOrderByID: false,
      updateStoreStatus: false,
      markOrder: false,
      getTranslation: false,
      resetMenuGroup: false,
      searchItems: false,
    },
  },
]
